export default __webpack_public_path__ + "static/media/signup-birds.1e7e339f.png";